module.exports = __webpack_public_path__ + "img/subscription.0f9fed15.svg";